<form (ngSubmit)="onSubmit()" [formGroup]="form">
  <div [hidden]="!loading" class="spinner">
    <div class="sk-spinner sk-spinner-pulse"></div>
  </div>
  <div class="create-test-topbar d-flex align-items-center flex-wrap py-15 px-20">
    <div class="left-col d-flex align-items-center max-w-[300px] me-20">
      <h3 class="me-20 mb-0">Create test</h3>
    </div>
    <div class="right-col d-flex align-items-center flex-grow-1 justify-content-end">
      <div class="inc-dec-box d-flex align-items-center bg-neutral-n1 me-0_8"
        [ngClass]="{ 'is-invalid': ttlInput.invalid && (ttlInput.dirty || ttlInput.touched) }">
        <span class="label">TTL (in seconds)</span>
        <input [(ngModel)]="ttl" formControlName="ttl" type="number" inputmode="numeric" class="form-control inc-dec-input" />
        <div class="icon-info-holder d-flex justify-content-center align-items-center bg-neutral-n3"
          tooltip="TTL is in seconds and should be greater than 60 and smaller than 600 (10 minutes)." tooltipPlacement="bottom">
          <i class="icon-info-1"></i>
        </div>
      </div>

      <div class="button-group">
        <button *ngIf="showButtons" [disabled]="countResults<= 0 || loading || !isFormValid" type="submit" class="btn btn-primary px-25 py-0_5">
          Run
          <span *ngIf="countResults">({{ countResults }})</span>
        </button>
      </div>
    </div>
  </div>
  <div class="create-test-body">
    <div class="create-test-box-wrapper d-flex flex-wrap">
      <div class="create-test-box-holder description">
        <div class="container my-5 h-100">
          <div class="row h-100">
            <div class="instruction-container">
              <div class="instruction-step">
                <span class="step-number">1</span>
                Select the country & network, time-to-live (TTL) and click "Run".
              </div>
              <div class="instruction-step">
                <span class="step-number">2</span>
                Our test number will appear in the results section below.
              </div>
              <div class="instruction-step">
                <span class="step-number">3</span>
                Initiate a call from your system to the provided test number within the time-to-live (TTL).
              </div>
              <div class="instruction-step">
                <span class="step-number">4</span>
                The test results status will update automatically if the call is received.
              </div>
              <div class="alert alert-primary me-25 my-25">
                <b>IMPORTANT:</b> Please note that your call will be automatically declined, which is the expected behavior. Do not attempt to call the provided
                test number more than once. The test results status will update automatically if the call is received. If you do not make a call within the
                <b>time-to-live (TTL)</b>, the test will fail.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="create-test-box-holder destinations">
        <div class="create-test-box px-20 py-20">
          <app-destinations-select (onChange)="calculateCountResults()" source="voice" [showManualAddNumbers]="isAdmin"></app-destinations-select>
        </div>
      </div>
    </div>
  </div>
</form>

<!-- <ng-template #confirmModalTpl let-dialogRef="dialogRef">
    <div class="modal-header mb-10">
        <div class="modal-title">
            <h3 class="d-inline-block">Test summary</h3>
            <button type="button" class="btn-close" (click)="dialogRef.close(false)">
                <span class="icon-close"></span>
            </button>
        </div>
    </div>
    <div class="modal-body">
        <div class="test-summary-destinations">
            <div class="py-0_7" *ngFor="let country of countries.getSelectedModels()">
                <span *ngIf="!country.custom">{{ country.countryName }}({{ country.mcc }})/{{ country.providerName }}({{ country.mnc }})</span>
                <span *ngIf="!country.custom && country.originalMnc">
                    <i class="icon-ported"></i> {{ country.originalProviderName }}({{ country.originalMnc }})</span>
                <span *ngIf="country.custom">{{ country.phonenumber }}</span>
            </div>
        </div>
    </div>
    <div class="modal-footer pt-15">
        <div class="button-holder d-flex justify-content-between">
            <button class="btn btn-outline-dark" (click)="dialogRef.close(false)">Cancel</button>
            <div class="d-flex justify-content-end align-items-center">
                <h5 class="mb-0">{{ this.countResults }} <span>tests for</span> &euro; {{ this.testsPrice }}</h5>
                <button class="btn btn-primary ms-15" (click)="dialogRef.close(true)">Confirm</button>
            </div>
        </div>
    </div>
</ng-template> -->

<ng-template #confirmModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Test summary</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div [hidden]="!loading" class="spinner">
      <div class="sk-spinner sk-spinner-pulse"></div>
    </div>

    <div class="d-flex modal-tabs-vertical">
      <ul class="nav flex-column">
        <div>
          <a class="nav-link cp active">
            <span class="nav-text"> Destinations </span>
          </a>
        </div>
      </ul>

      <div class="tab-content section-parent" id="parentDiv">
        <div id="countries" class="section-child">
          <ul class="modal-tab-list modal-tab-table-list">
            <li class="title mb-10">{{countries.getSelectedModels().length}} destinations</li>
            <div class="py-0_7" *ngFor="let country of countries.getSelectedModels()">
              <span *ngIf="!country.custom">{{ country.countryName }}({{ country.mcc }})/{{ country.providerName }}({{ country.mnc }})</span>
              <span *ngIf="!country.custom && country.originalMnc">
                <i class="icon-ported"></i> {{ country.originalProviderName }}({{ country.originalMnc }})</span>
              <span *ngIf="country.custom">{{ country.phonenumber }}</span>
            </div>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer pt-15">
    <div class="button-holder d-flex justify-content-between">
      <div class="d-flex justify-content-start gap-15">
        <button class="btn btn-outline-dark" (click)="dialogRef.close(false)">Cancel</button>
      </div>

      <div class="d-flex justify-content-end align-items-center">
        <h5 class="mb-0">{{ this.countResults }} <span>tests for</span> € {{ this.testsPrice }}</h5>
        <button class="btn btn-primary ms-15" (click)="dialogRef.close(true)">Confirm</button>
      </div>
    </div>
  </div>
</ng-template>
